module.exports = __webpack_public_path__ + "calendar-grey.png?500309720e8619d0bd2074e9234e051d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/calendar-grey.png
// module id = 925
// module chunks = 0